import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
var _excluded = ["disableCssTransforms"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import * as styles from "./styles";
import { IconCheckmark } from "../../../foundations/Iconography/IconCheckmark";
export var Checkbox = function Checkbox(_ref) {
  var disableCssTransforms = _ref.disableCssTransforms,
    props = _objectWithoutProperties(_ref, _excluded);
  var checkmarkStyles = [styles.checkmark, props.checked && styles.checkmarkChecked];
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(_StyledInput, _extends({}, props, {
    type: "checkbox",
    $_css2: styles.input
  })), /*#__PURE__*/React.createElement(_StyledIconCheckmark, {
    color: props.disabled ? "var(--neutral-black-70)" : "var(--neutral-white-base)",
    disableCssTransforms: disableCssTransforms,
    $_css3: checkmarkStyles
  }));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledInput = _styled2("input")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledIconCheckmark = /*#__PURE__*/_styled3(IconCheckmark).withConfig({
  displayName: "Checkbox___StyledIconCheckmark",
  componentId: "sc-4qc43y-0"
})(["", ""], function (p) {
  return p.$_css3;
});